(function () {
  'use strict';

  var SORTERS = {
    'price-asc': function (a, b) {
      return num(a, 'price') - num(b, 'price') || num(a, 'index') - num(b, 'index');
    },
    'price-desc': function (a, b) {
      return num(b, 'price') - num(a, 'price') || num(a, 'index') - num(b, 'index');
    },
    rating: function (a, b) {
      return num(b, 'rating') - num(a, 'rating') || num(b, 'reviews') - num(a, 'reviews') || num(a, 'index') - num(b, 'index');
    },
    featured: function (a, b) {
      return num(a, 'index') - num(b, 'index');
    }
  };

  function num(el, key) {
    return parseFloat(el.getAttribute('data-' + key)) || 0;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function viewParam() {
    var match = window.location.search.match(/[?&]view=([^&#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function withView(href) {
    var view = viewParam();
    var url = new URL(href, window.location.origin);
    if (view && !url.searchParams.get('view')) {
      url.searchParams.set('view', view);
    }
    return url.pathname + url.search + url.hash;
  }

  function applySort(section, value) {
    var grid = section.querySelector('[data-wly-coll-grid]');
    if (!grid) return;
    var sorter = SORTERS[value] || SORTERS.featured;
    var items = toArray(grid.querySelectorAll('[data-wly-coll-item]'));
    items.sort(sorter);
    for (var i = 0; i < items.length; i++) {
      grid.appendChild(items[i]);
    }
  }

  function headerOffset() {
    var header = document.querySelector('[data-wly-header]');
    if (!header) return 0;
    var wrap = header.closest('.shopify-section') || header;
    var position = window.getComputedStyle(wrap).position;
    if (position !== 'sticky' && position !== 'fixed') return 0;
    return wrap.getBoundingClientRect().height;
  }

  function setStickyTop(section) {
    section.style.setProperty('--wly-coll-sticky-top', headerOffset() + 'px');
  }

  function updateArrow(scroller, arrow) {
    if (!scroller || !arrow) return;
    var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 8;
    var overflows = scroller.scrollWidth > scroller.clientWidth + 4;
    arrow.hidden = !overflows || atEnd;
  }

  function initTabs(section) {
    var scroller = section.querySelector('[data-wly-coll-tabs]');
    var arrow = section.querySelector('[data-wly-coll-tabs-next]');
    if (!scroller) return;
    var active = scroller.querySelector('.is-active');
    if (active && scroller.scrollWidth > scroller.clientWidth) {
      var behavior = scroller.style.scrollBehavior;
      scroller.style.scrollBehavior = 'auto';
      scroller.scrollLeft = Math.max(0, active.parentNode.offsetLeft - 20);
      scroller.style.scrollBehavior = behavior;
    }
    updateArrow(scroller, arrow);
    scroller.addEventListener('scroll', function () {
      updateArrow(scroller, arrow);
    }, { passive: true });
    if (arrow) {
      arrow.addEventListener('click', function () {
        scroller.scrollBy({ left: Math.round(scroller.clientWidth * 0.7), behavior: 'smooth' });
      });
    }
    var links = toArray(section.querySelectorAll('[data-wly-coll-tab]'));
    links.forEach(function (link) {
      link.setAttribute('href', withView(link.getAttribute('href')));
    });
  }

  function keepTabsInView(section) {
    var bar = section.querySelector('[data-wly-coll-tabs-bar]');
    if (!bar) return;
    var stuck = window.getComputedStyle(bar).position === 'sticky';
    var target = stuck ? section.querySelector('.wly-coll__results') : bar;
    if (!target) return;
    var offset = headerOffset() + (stuck ? bar.getBoundingClientRect().height : 0);
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    if (window.pageYOffset > top) {
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  function load(section, href, push) {
    var url = withView(href);
    var sortSelect = section.querySelector('[data-wly-coll-sort]');
    var sortValue = sortSelect ? sortSelect.value : 'featured';
    section.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(section.id) || doc.querySelector('[data-wly-coll]');
        var freshRoot = fresh ? fresh.querySelector('[data-wly-coll-root]') : null;
        var root = section.querySelector('[data-wly-coll-root]');
        if (!freshRoot || !root) {
          window.location.href = url;
          return;
        }
        root.innerHTML = freshRoot.innerHTML;
        if (doc.title) document.title = doc.title;
        if (push && window.history && history.pushState) {
          history.pushState({ wlyColl: section.id }, '', url);
        }
        section.classList.remove('is-loading');
        init(section);
        var newSelect = section.querySelector('[data-wly-coll-sort]');
        if (newSelect && newSelect.querySelector('option[value="' + sortValue + '"]')) {
          newSelect.value = sortValue;
          applySort(section, sortValue);
        }
        keepTabsInView(section);
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  function init(section) {
    setStickyTop(section);
    initTabs(section);
    var select = section.querySelector('[data-wly-coll-sort]');
    if (select) {
      select.addEventListener('change', function () {
        applySort(section, select.value);
      });
      if (select.value !== 'featured') applySort(section, select.value);
    }
  }

  function bindSection(section) {
    if (section.getAttribute('data-wly-coll-bound')) return;
    section.setAttribute('data-wly-coll-bound', 'true');
    section.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('[data-wly-coll-tab]') : null;
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      if (link.classList.contains('is-active')) {
        event.preventDefault();
        return;
      }
      if (!window.fetch || !window.DOMParser) return;
      event.preventDefault();
      load(section, link.href, true);
    });
    init(section);
  }

  function setup() {
    var sections = toArray(document.querySelectorAll('[data-wly-coll]'));
    sections.forEach(bindSection);
    if (sections.length && window.history && history.replaceState && !(history.state && history.state.wlyColl)) {
      history.replaceState({ wlyColl: sections[0].id }, '', window.location.href);
    }
  }

  window.addEventListener('popstate', function (event) {
    if (!event.state || !event.state.wlyColl) return;
    var section = document.querySelector('[data-wly-coll]');
    if (section) load(section, window.location.href, false);
  });

  window.addEventListener('resize', function () {
    toArray(document.querySelectorAll('[data-wly-coll]')).forEach(function (section) {
      setStickyTop(section);
      updateArrow(section.querySelector('[data-wly-coll-tabs]'), section.querySelector('[data-wly-coll-tabs-next]'));
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-wly-coll]');
    if (section) bindSection(section);
  });
})();
